import { useEffect, useState } from 'react';
import styles from './list.module.css';
import { Button, IconButton, Dialog, DialogTitle, DialogContent, Snackbar, Alert, Checkbox } from '@mui/material';
import { Add, Close } from '@mui/icons-material';
import AddPermissionForm from './AddPermissionForm';
import axios from 'axios';
import Loader from '../../components/Loader';
import UserPermissionsLoader from './UserPermissionsLoader';
import { authData, withAdminAuth } from "../../components/GetAuth";
import PageHeader from '../../components/PageHeader';
import { useWebsite } from '../../../context/WebsiteContext';
import { useSiteBranding } from '../../../hooks/useSiteBranding';

const ChildPermList = ({ perm, roleList, cngStatus }) => {
  const auth = authData();

  return <tr className={`${styles.PermChildRow}`}>
    <td className={`${styles.PermNameCell}`}>
      <span className={`${styles.PermChildName}`}>
        {perm?.name}{auth?.user_type === 1 && <> (<strong>{perm?.slug}</strong>)</>}
      </span>
    </td>
    {roleList?.map(i => {
      return <td key={i?.id} className={`${styles.PermCheckboxCell}`}>
        <Checkbox disabled={i?.id === 2} defaultChecked={i?.permissions?.indexOf(perm?.id) > -1} onChange={(e) => cngStatus(e, i?.id, perm?.id)} />
      </td>
    })}
  </tr>
}

const UserPermissionsList = () => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [formOpen, setFormOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarType, setSnackbarType] = useState('success');
  const [permissionList, setPermissionList] = useState([]);
  const [roleList, setRoleList] = useState([]);

  const { websiteData } = useWebsite();
  useSiteBranding("User permissions", websiteData);

  useEffect(() => {
    const fetchPerms = () => {
      axios.get(process.env.REACT_APP_API_URL + 'v1/user-permissions', {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then(response => {
        setContentLoading(false);
        setPermissionList(response.data.data);
      }).catch(eroor => {
        setContentLoading(false);
      });
    }

    fetchPerms();
  }, [API_TOKEN]);

  useEffect(() => {
    const fetchRoles = () => {
      axios.get(process.env.REACT_APP_API_URL + 'v1/user-role-list', {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then(response => {
        setContentLoading(false);
        setRoleList(response.data.data);
      }).catch(error => {
        setContentLoading(false);
      });
    }

    fetchRoles();
  }, [API_TOKEN]);

  const cngStatus = (e, roleId, permId) => {
    let postData = { role_id: roleId, permission_id: permId };
    setLoading(true);
    if (e.target.checked) {
      axios.post(process.env.REACT_APP_API_URL + 'v1/add-role-perm', postData, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then(response => {
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + 'v1/del-role-perm', postData, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then(response => {
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
    }
  }


  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>
      <PageHeader title="User Permissions" />
      <div className={`${styles.MainCard}`}>

        {contentLoading && <UserPermissionsLoader />}

        {!contentLoading && <>
          {auth?.user_type === 1 && <div className={`${styles.TableFilterHead}`} style={{ justifyContent: 'flex-end' }}>
            <div className={`${styles.TableFilterBUSec}`}>
              <Button className={`${styles.TableAddBU}`} onClick={(e) => { setFormOpen(true); }}><Add /> Permissions</Button>
            </div>
          </div>}

          <div className={`${styles.PermTableWrap}`}>
            <table className={`${styles.PermTable}`}>
              <tbody>
                <tr className={`${styles.PermRoleHeadRow}`}>
                  <th className={`${styles.PermNameCell}`}>&nbsp;</th>
                  {roleList?.map(i => (
                    <th key={i?.id}>{i?.name}</th>
                  ))}
                </tr>
                {permissionList?.map(perm => (
                  <>
                    <tr key={`cat-${perm?.id}`} className={`${styles.PermCategoryRow}`}>
                      <td className={`${styles.PermNameCell}`}>{perm?.name}</td>
                      {roleList?.map(i => (
                        <td key={i?.id}>&nbsp;</td>
                      ))}
                    </tr>
                    {perm?.childrens?.map(j => (
                      <ChildPermList key={j?.id} perm={j} roleList={roleList} cngStatus={cngStatus.bind(this)} />
                    ))}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </>}
      </div>
    </div>

    <Dialog
      open={formOpen}
      onClose={(e) => setFormOpen(false)}
      fullWidth
      maxWidth="xs"
      className={`${styles.NewPopUp}`}
    >
      <DialogTitle className={`${styles.PopupTitleBar}`}>
        Add User Permission
        <IconButton aria-label="close" onClick={(e) => setFormOpen(false)} className={`${styles.PopupCloseBU}`}><Close /></IconButton>
      </DialogTitle>
      <DialogContent>
        <AddPermissionForm setFormOpen={setFormOpen.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} />
      </DialogContent>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
}

export default withAdminAuth(UserPermissionsList);